<template>
  <button
    :type="type"
    :class="[
      'btn',
      variantClass,
      { 'btn-block': block, 'btn-loading': loading },
    ]"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span v-if="loading" class="btn-spinner"></span>
    <slot />
  </button>
</template>

<script>
// ...existing code...
export default {
  name: "AppButton",
  props: {
    type: {
      type: String,
      default: "button",
    },
    variant: {
      type: String,
      default: "primary", // primary, secondary, outline, danger
    },
    block: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variantClass() {
      return `btn-${this.variant}`;
    },
  },
  methods: {
    handleClick(event) {
      // Alleen click event emiteren als het geen submit is
      if (this.type !== "submit") {
        this.$emit("click", event);
      }
    },
  },
};
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border 0.2s;
  outline: none;
  min-height: 2.8rem;
  min-width: 2.8rem;
  box-sizing: border-box;
  gap: 0.5em;
}
.btn-block {
  width: 100%;
  display: flex;
}
.btn-primary {
  background: var(--primary_color, #4f46e5);
  color: #000;
}
.btn-secondary {
  background: var(--surface, #fff);
  color: var(--primary_color, #4f46e5);
  border: 1px solid var(--primary_color, #4f46e5);
}
.btn-outline {
  background: transparent;
  color: var(--primary_color, #4f46e5);
  border: 1px solid var(--primary_color, #4f46e5);
}
.btn-danger {
  background: #ef4444;
  color: #fff;
}
.btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}
.btn:disabled,
.btn.btn-loading {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-spinner {
  border: 2px solid #fff;
  border-top: 2px solid #4f46e5;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
/* Zorg dat iconen in buttons altijd gecentreerd zijn en geen extra hoogte veroorzaken */
.btn :deep(svg),
.btn :deep(.offerte-action-icon) {
  height: 1.3em !important;
  width: 1.3em !important;
  min-height: 0;
  min-width: 0;
  vertical-align: middle;
  display: inline-block;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
